// Central dayjs init for app-frontend.
//
// Plugin extends are global — any module that imports dayjs from anywhere
// gets the same configured instance, so this side-effect only runs once
// (regardless of how many files import from here). Importing from this
// module (instead of `dayjs` directly) makes the plugin dependency explicit
// in the import graph and prevents the build from succeeding if someone
// removes a plugin we still use.

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(advancedFormat); // "Do" ordinal token (e.g. PsychologicalDataTable "MMM Do")

export default dayjs;
